// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hyZ9","clinicsSelect":"styles_clinicsSelect__30Hl2"};